import React from 'react';
import { Reviews, List, ListItem, StockIndicator, Violator } from '@hpi-sox/hpstellar-core/visId';

import { Helpers } from '../../../../../core';
import { useGetProductPrice } from '../../../../../hooks/useProductPrice';
import { getStockIndicator } from '../../../../get-product-props';

import './product-labels.less';

const getTitleCase = Helpers.memoize(str => Helpers.titleCase(str));

const STOCK_INDICATOR_MAP = {
    'Currently out of stock': 'Out of stock',
};

const getLabels = (usageLabels, product) => {
    const { productType } = product || {};
    let labels = [];

    if (Array.isArray(usageLabels)) {
        labels = usageLabels.map(usageLabel => getTitleCase(usageLabel));
    }

    if (productType && productType !== true) {
        labels.push(getTitleCase(productType));
    }

    return labels;
};

const ProductUsageLabels = ({ usageLabel }) =>
    Array.isArray(usageLabel) &&
    usageLabel.length > 0 && (
        <div className="usage-label-wrapper">
            {usageLabel.map((label, idx) => (
                <Violator key={idx} label={label} theme="light" backgroundColor="black" variant="footnotes" />
            ))}
        </div>
    );

export const ProductStockIndicator = ({ product }) => {
    const priceObj = useGetProductPrice(product);
    const { stockIndicator } = getStockIndicator(priceObj);
    const { stockMessage, color } = stockIndicator || {};
    const stockIndicatorLabel = STOCK_INDICATOR_MAP[stockMessage] || stockMessage;
    return stockMessage ? (
        <div className="stock-indicator-wrapper">
            <StockIndicator label={stockIndicatorLabel} color={color} />
        </div>
    ) : null;
};

export default ({ product, headerProps, score, reviewsLink, isMobile }) => {
    const { usageLabel, offerMessage, customElement } = headerProps;
    const { sustainability } = customElement || {};
    return (
        <div className="visid-label-container">
            {isMobile && (
                <>
                    {offerMessage && <Violator label={offerMessage} theme="light" backgroundColor="red" />}
                    {['string', 'number'].includes(typeof score) && (
                        <Reviews
                            score={score}
                            GlobalLinkProps={{ to: reviewsLink }}
                            className="product-rating"
                            reviewsLabel=" "
                        />
                    )}
                </>
            )}
            <ProductStockIndicator product={product} />
            <ProductUsageLabels usageLabel={getLabels(usageLabel, product)} />
            {isMobile && sustainability}
        </div>
    );
};
